import {
  FetchSystemSettingsRequest,
  FetchSystemSettingsSuccess,
  FetchSystemSettingsFailure,
  UpdateSystemSettingsRequest,
  UpdateSystemSettingsSuccess,
  UpdateSystemSettingsFailure,
} from './system-settings.actions'
import { SystemSettingsService } from './system-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as SystemSettingsTypes from './system-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class SystemSettingsEffects {
  constructor(
    private actions: Actions,
    private systemSettingsService: SystemSettingsService,
  ) {}

  FetchSystemSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SystemSettingsTypes.FETCH_SYSTEM_SETTINGS_REQUEST),
      switchMap((action: FetchSystemSettingsRequest) => {
        return this.systemSettingsService.fetchSystemSettings().pipe(
          map((result) => {
            return new FetchSystemSettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchSystemSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateSystemSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SystemSettingsTypes.UPDATE_SYSTEM_SETTINGS_REQUEST),
      switchMap((action: UpdateSystemSettingsRequest) => {
        return this.systemSettingsService
          .updateSystemSettings(action.payload)
          .pipe(
            switchMap((result) => {
              return [new UpdateSystemSettingsSuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdateSystemSettingsFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
